import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#1d1d1d";
function BQ({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  fillRule="evenodd" d="M7.472 11.966a2.887 2.887 0 002.901 2.886c1.592-.01 2.885-1.287 2.886-2.85A2.875 2.875 0 0010.365 9.1c-1.599.002-2.894 1.284-2.894 2.866m.002 3.105v.954H6V5.25q.63.01 1.058.454.408.428.406 1.022c-.004.71-.002 1.42-.002 2.164 1.03-.86 2.177-1.284 3.513-1.08 1.324.203 2.34.869 3.033 2.008 1.046 1.722.707 3.92-.809 5.288-1.478 1.335-3.934 1.542-5.724-.036m4.77.935c.058-.036.089-.056.121-.073a4.3 4.3 0 001.238-.916.4.4 0 01.285-.135c1.252-.072 2.381-1.08 2.593-2.313.28-1.62-.705-3.05-2.332-3.36a.96.96 0 01-.578-.315c-.3-.331-.664-.59-1.052-.813-.033-.018-.065-.039-.119-.072.739-.202 1.458-.25 2.187-.085.725.165 1.35.52 1.935 1.006v-.957H18V18.75a1.47 1.47 0 01-1.05-.451 1.43 1.43 0 01-.415-1.032v-2.153c-1.273 1.067-2.682 1.387-4.291.892" clipRule="evenodd" /></Svg>;
}
BQ.DefaultColor = DefaultColor;
export default BQ;